module.exports = __webpack_public_path__ + "img/CerealCityScience_logo.daaa6e04.svg";